// Documentos legais aceites no checkout. A versão de cada um fica gravada
// em cada encomenda (prova do que o cliente aceitou) — sempre que o texto de
// um documento mudar, sobe-se aqui a `version` e a `effectiveDate`.
//
// O backend tem as mesmas versões em src/config/legalDocuments.ts: as duas
// cópias têm de estar sempre iguais, senão o checkout é recusado.
//
// `version: null` = documento ainda não publicado — a página não aparece no
// rodapé nem no produto, e o checkout não o pede.

export type LegalDocumentKey = 'general' | 'meta';

export type LegalDocument = {
  key: LegalDocumentKey;
  title: string;
  path: string;
  version: string | null;
  effectiveDate: string | null; // AAAA-MM-DD
};

export const LEGAL_DOCUMENTS: Record<LegalDocumentKey, LegalDocument> = {
  general: {
    key: 'general',
    title: 'Condições Gerais de Venda',
    path: '/condicoes-gerais-venda',
    version: '1.1',
    effectiveDate: '2026-10-18',
  },
  meta: {
    key: 'meta',
    title: 'Condições Específicas de Venda Ray-Ban Meta e Oakley Meta',
    path: '/condicoes-venda-meta',
    version: '1.2',
    effectiveDate: '2026-10-27',
  },
};

export const isPublished = (doc: LegalDocument): boolean => doc.version !== null;

export function formatEffectiveDate(date: string | null): string {
  if (!date) return '';
  const [year, month, day] = date.split('-');
  return `${day}/${month}/${year}`;
}
